<template>
  <div id="dept">

      <el-table ref="deptTable" :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border :default-expand-all="false" :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        @row-click="selectDept" highlight-current-row :show-header="sh">
        <el-table-column prop="label" label="请选择" width></el-table-column>
      </el-table>

  </div>
</template>
<script>
export default {
  name: "dept",
  data() {
    return {
      tableData: [],
      sh: false
    };
  },
  created: function() {
    var _self = this;
      this.$axios.get("/department/departmentTree").then(response => {
        if (
          response.data !== null &&
          response.data !== "" &&
          response.data !== undefined
        ) {

          _self.tableData = JSON.parse(response.data);
          _self.tableData.push({
            id: -1,
            label: '外部通讯录',
            level: 1,
            maxsort: 1,
            parentid: 0,
            sort: 2,
            children: [
              {
                id: -2,
                label: "我的",
                level: 2,
                maxsort: 1,
                parentid: -1,
                sort: 1,
              },{
                id: -3,
                label: "共享",
                level: 2,
                maxsort: 1,
                parentid: -1,
                sort: 1,
              }
            ]
          })
        }
      });
  },
  components: {},
  methods: {
    selectDept(row, column, event) {
      this.$refs['deptTable'].toggleRowExpansion(row)
      this.$emit("departmentSelect",{
        id: row.id,
        name: row.label
      })
    },
    renderContent(h, { node, data, store }) {
      if (data.parentId == "0") {
        return (
          <span class="custom-tree-node">
            <i class="el-icon-s-home"></i>
            <span style="margin-left:5px;">{node.label}</span>
          </span>
        );
      } else {
        return (
          <span class="custom-tree-node">
            <i class="el-icon-office-building"></i>
            <span style="margin-left:5px;">{node.label}</span>
          </span>
        );
      }
    }
  }
};
</script>
<style  scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/deptMenu.vue